import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MPopupTimerCon = styled.div`
  line-height: 1.35;
  font-family: ${props => props.$fontFamily} !important;
  font-size: ${props => props.$fontSize}px;
  color: ${props => props.$color};
  font-weight: ${props => props.$fontWeight};
  font-style: ${props => props.$fontStyle};
  text-decoration: ${props => props.$textDecoration};
  text-align: ${props => props.$textAlignment};
`;

export const MPopupTimer = props => {
  const {
    offerTimerText,
    seconds,
    minutes,
    fontSize,
    mobileFontSize,
    color,
    fontStyle,
    fontWeight,
    textDecoration,
    fontFamily = 'inherit',
    textAlignment,
    children,
  } = props;
  const textWithMinutesAndSeconds = offerTimerText
    .replace('{{minutes_remaining}}', minutes)
    .replace('{{seconds_remaining}}', seconds);
  return (
    <MPopupTimerCon
      $fontSize={fontSize}
      $mobileFontSize={mobileFontSize}
      $color={color}
      $fontStyle={fontStyle}
      $fontWeight={fontWeight}
      $textDecoration={textDecoration}
      $fontFamily={fontFamily}
      $textAlignment={textAlignment}
    >
      {textWithMinutesAndSeconds || children}
    </MPopupTimerCon>
  );
};

MPopupTimer.propTypes = {
  offerTimerText: PropTypes.string,
  minutes: PropTypes.string,
  seconds: PropTypes.string,
  children: PropTypes.node,
  fontSize: PropTypes.string,
  mobileFontSize: PropTypes.string,
  color: PropTypes.string,
  fontStyle: PropTypes.string,
  fontWeight: PropTypes.string,
  textDecoration: PropTypes.string,
  fontFamily: PropTypes.string,
  textAlignment: PropTypes.string,
};
